import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

export const fetchTrafficEventTime = async (params = '') => {
  const url = `${URLS.BACK_DSH}${APIS.trafficEventTime(params)}`;
  return await request.get(url);
};

export const fetchTrafficEventCnt = async (params = '') => {
  const url = `${URLS.BACK_DSH}${APIS.trafficEventCnt(params)}`;
  return await request.get(url);
};
